import React, { useState } from "react";
import { formatDateWithTimeInZone } from "../../../../classes/utils/DateUtils";
import { useUser } from "../../../../classes/contexts/UserContext";
import IconButton from "../../../../components/iconButton/IconButton";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { useAppContext } from "../../../../classes/contexts/AppContext";
import { useNotification } from "../../../../classes/contexts/NotificationContext";
import { SnackbarType } from "../../../../classes/enums/SnackbarTypeEnum";
import { downloadReport } from "../../../../services/ReportService";
import DeleteReportModal from "./DeleteReportModal";
import "./ReportItem.css";

const ReportItem = ({ report, patientId, onReportDeleted }) => {
  const { t } = useTranslation();
  const { showPopup } = useAppContext();
  const { addNotification } = useNotification();
  const { dateSettings } = useUser();
  const [isDownloading, setIsDownloading] = useState(false);
  const formattedDate = formatDateWithTimeInZone(report.date, undefined, {
    locale: dateSettings?.locale,
  });

  const handleDownload = async e => {
    e.stopPropagation();
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      await downloadReport(patientId, report.title);
    } catch (error) {
      addNotification(SnackbarType.ERROR, error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    showPopup(
      <DeleteReportModal
        patientId={patientId}
        report={report}
        onReportDeleted={onReportDeleted}
      />
    );
  };

  return (
    <div className="report-item">
      <div className="report-item-header">
        <div className="report-item-date">{formattedDate}</div>
      </div>
      <div className="report-item-content">
        <div className="report-item-title">{report.title}</div>
        <div className="report-item-actions">
          <IconButton
            icon={IconsEnum.DOWNLOAD}
            onClick={handleDownload}
            noBgColor
            disabled={isDownloading}
            aria-label={t("441")}
            title={t("441")}
          />
          <IconButton
            icon={IconsEnum.DELETE}
            onClick={handleDelete}
            noBgColor
            aria-label={t("442")}
            title={t("442")}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportItem;
